import { NonEmptyArray } from 'fp-ts/NonEmptyArray'

type Cases<Enum extends string | number, R> = {
    [key in Enum]: R;
}

export const enumMatchAll = <T extends string | number>() => <C extends Cases<T, unknown>>(cases: C) => (value: keyof C): C[keyof C] => {
    return cases[value]
}

export const enumMatch = <T extends string | number>() => <C extends Partial<Cases<T, unknown>>>(cases: C, def: C[keyof C]) => (value: T): C[keyof C] => {
    return cases[value ?? def]
}

export const enumIs = <T extends string | number>() => <Keys extends T[]>(variants: Keys) => (value: T): boolean => {
    return variants.includes(value)
}

export const enumMatchMultiple = <T extends string | number>() => <R>(def: R, ...cases: NonEmptyArray<[NonEmptyArray<T>, R]>) => (value: T): R => {
    for(const [variants, result] of cases) {
        if (enumIs()(variants)(value)) {
            return result
        }
    }
    return def
}